<template>
  <div class="GenderAge">
    <Male
      v-if="male"
      :age="age" />
    <Female
      v-if="female"
      :age="age" />
  </div>
</template>

<script>
import Male from "@/components/Male";
import Female from "@/components/Female";
import moment from "moment";

export default {
  components: { Male, Female },
  data: function() {
    return {
    }
  },

  props: {
    birthdate: {
      type: String,
    },

    gender: {
      type: String,
      required: false,
    },
  },

  computed: {
    age() {
      if (this.birthdate) {
        return moment().diff(this.birthdate, "years");
      }
      return 0;
    },

    male() {
      return this.gender === "MALE";
    },

    female() {
      return this.gender === "FEMALE";
    },
  },

  filters: {},
}
</script>

<style lang="scss" scoped>
.GenderAge {
}
</style>
